/**
 * Sample data for development and demo mode
 * Used when Supabase is not connected or for testing
 */

export const ROOMS = [
  {
    id: 'skeff-full',
    name: 'The Full Skeffington Suite',
    capacity_theatre: 540,
    capacity_boardroom: 200,
    capacity_classroom: 400,
    capacity_ushape: 220,
    capacity_banquet: 380,
    full_day_price: 400,
    half_day_price: 300,
    colour: '#EC4899',
    venue_type: 'function_room',
    is_dual_purpose: false,
  },
  {
    id: 'skeff1',
    name: 'Small Skeff',
    capacity_theatre: 120,
    capacity_boardroom: 80,
    capacity_classroom: 100,
    capacity_ushape: 80,
    capacity_banquet: 100,
    full_day_price: 265,
    half_day_price: 200,
    colour: '#3B82F6',
    venue_type: 'function_room',
    is_dual_purpose: false,
  },
  {
    id: 'skeff2',
    name: 'Big Skeff',
    capacity_theatre: 250,
    capacity_boardroom: 120,
    capacity_classroom: 200,
    capacity_ushape: 120,
    capacity_banquet: 230,
    full_day_price: 265,
    half_day_price: 200,
    colour: '#8B5CF6',
    venue_type: 'function_room',
    is_dual_purpose: false,
  },
  {
    id: 'annalee',
    name: 'The Annalee Room',
    capacity_theatre: 35,
    capacity_boardroom: 20,
    capacity_classroom: 25,
    capacity_ushape: 20,
    capacity_banquet: 20,
    full_day_price: 240,
    half_day_price: 190,
    colour: '#F59E0B',
    venue_type: 'function_room',
    is_dual_purpose: false,
  },
  {
    id: 'corrick',
    name: 'The Corrick Suite',
    capacity_theatre: null,
    capacity_boardroom: 12,
    capacity_classroom: null,
    capacity_ushape: 12,
    capacity_banquet: null,
    full_day_price: 190,
    half_day_price: 170,
    colour: '#10B981',
    venue_type: 'function_room',
    is_dual_purpose: false,
  },
  {
    id: 'new-bar',
    name: 'New Bar',
    capacity_banquet: 30,
    colour: '#D97706',
    venue_type: 'event_space',
    is_dual_purpose: false,
  },
  {
    id: 'foyer',
    name: 'Foyer',
    capacity_banquet: 100,
    colour: '#78716C',
    venue_type: 'event_space',
    is_dual_purpose: false,
  },
  {
    id: 'reynards',
    name: 'Reynards Restaurant',
    table_cover_capacity: 50,
    colour: '#6366F1',
    venue_type: 'table_venue',
    is_dual_purpose: true,
  },
  {
    id: 'randr',
    name: 'R&R',
    table_cover_capacity: 45,
    colour: '#EF4444',
    venue_type: 'table_venue',
    is_dual_purpose: true,
  },
  {
    id: 'brewery',
    name: 'Brewery Bar',
    table_cover_capacity: 60,
    colour: '#D97706',
    venue_type: 'table_venue',
    is_dual_purpose: false,
  },
];

export const VENUE_COMBINATIONS = [
  { parent_id: 'skeff-full', child_id: 'skeff1', type: 'partition' },
  { parent_id: 'skeff-full', child_id: 'skeff2', type: 'partition' },
];

// ─── NORMAL EVENT PIPELINE (5 stages) ───
export const PIPELINE_STAGES = [
  'enquiry',
  'quote_sent',
  'confirmed',
  'deposit_paid',
  'complete',
];

// ─── WEDDING PIPELINE (8 stages) ───
export const WEDDING_PIPELINE_STAGES = [
  'enquiry',
  'quote_sent',
  'provisional_date',
  'confirmed',
  'deposit_paid',
  'food_tasting',
  'first_payment',
  'second_payment',
  'complete',
];

// Combined labels & colours for ALL stages (normal + wedding)
export const STAGE_LABELS = {
  enquiry: 'Enquiry',
  quote_sent: 'Quote Sent',
  provisional_date: 'Provisional Date',
  confirmed: 'Confirmed',
  deposit_paid: 'Deposit Paid',
  food_tasting: 'Food Tasting & Details',
  first_payment: '1st Payment (€2.5k)',
  second_payment: '2nd Payment (75%)',
  complete: 'Complete',
  archived: 'Archived',
};

export const STAGE_COLOURS = {
  enquiry: '#94A3B8',
  quote_sent: '#F59E0B',
  provisional_date: '#FB923C',
  confirmed: '#3B82F6',
  deposit_paid: '#8B5CF6',
  food_tasting: '#EC4899',
  first_payment: '#14B8A6',
  second_payment: '#0EA5E9',
  complete: '#10B981',
  archived: '#6B7280',
};

/** Get the correct pipeline stages for an event type */
export const getPipelineStages = (eventType) => {
  if (eventType?.toLowerCase() === 'wedding') return WEDDING_PIPELINE_STAGES;
  return PIPELINE_STAGES;
};

export const EVENT_SUBTYPES = [
  'Birthday',
  'Anniversary',
  'Communion',
  'Christening',
  'Funeral',
  'Community Event',
  'Music Night',
  'Charity Event',
  'Conference',
  'Training',
  'Private Party',
  'Other',
];

export const SAMPLE_EVENTS = [
  {
    id: 'evt001',
    name: 'Abbott Team Building',
    client: 'Michael Donohue',
    clientPhone: '087 123 4567',
    clientEmail: 'm.donohue@abbott.ie',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-04-08',
    startTime: '09:00',
    endTime: '17:00',
    guests: 150,
    stage: 'complete',
    setup: 'theatre',
    equipment: ['projector', 'sound_system'],
    fbItems: ['morning_tea', 'afternoon_tea', 'lunch'],
    roomHire: 400,
    packageTotal: 603.50,
    depositPaid: 603.50,
    notes: 'Confirmed and invoiced',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt002',
    name: 'Tusla Annual Training',
    client: 'Tusla Child & Family Agency',
    clientPhone: '049 437 8900',
    clientEmail: 'bookings@tusla.ie',
    type: 'corporate',
    venue_id: 'skeff2',
    date: '2026-04-10',
    startTime: '09:00',
    endTime: '17:00',
    guests: 80,
    stage: 'complete',
    setup: 'classroom',
    equipment: ['projector', 'flipchart'],
    fbItems: ['morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 265,
    packageTotal: 520.00,
    depositPaid: 520.00,
    notes: 'Delivered successfully',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt003',
    name: 'NOWGROUP Workshop',
    client: 'Kellie Ann',
    clientPhone: '048 7126 0026',
    clientEmail: 'kellie.ann@nowgroup.org',
    type: 'corporate',
    venue_id: 'skeff1',
    date: '2026-04-15',
    startTime: '14:00',
    endTime: '18:00',
    guests: 45,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: ['projector'],
    fbItems: ['afternoon_tea'],
    roomHire: 200,
    packageTotal: 250.00,
    depositPaid: 100.00,
    notes: 'Half-day rate applied',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt004',
    name: 'Parkinsons Fundraiser Gala',
    client: 'Parkinsons Ireland',
    clientPhone: '01 872 2234',
    clientEmail: 'events@parkinsons.ie',
    type: 'charity',
    venue_id: 'skeff-full',
    date: '2026-04-17',
    startTime: '19:00',
    endTime: '23:00',
    guests: 280,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting'],
    fbItems: ['welcome_cocktail', 'canapes', 'dinner'],
    roomHire: 400,
    packageTotal: 3370.00,
    depositPaid: 1685.00,
    notes: 'Premium gala event with entertainment',
    billingType: 'group',
    consumption: 1370.00,
  },
  {
    id: 'evt005',
    name: 'Sarah & James Wedding Reception',
    client: 'Sarah & James McNally',
    clientPhone: '086 789 0123',
    clientEmail: 'sarahmcnally@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-06-19',
    endDate: '2026-06-21',
    startTime: '18:00',
    endTime: '23:30',
    guests: 180,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting', 'dance_floor'],
    fbItems: ['cocktail_hour', 'dinner', 'dessert', 'evening_snacks'],
    roomHire: 400,
    packageTotal: 13500.00,
    depositPaid: 6750.00,
    notes: 'Fri–Sun wedding weekend. Includes uplighting and custom menu.',
    billingType: 'group',
    consumption: 8850.00,
  },
  {
    id: 'evt006',
    name: 'Emma & Ciaran Wedding Reception',
    client: 'Emma & Ciaran O\'Brien',
    clientPhone: '085 456 7890',
    clientEmail: 'emmaobrien@outlook.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-08-14',
    endDate: '2026-08-16',
    startTime: '17:30',
    endTime: '23:30',
    guests: 220,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting', 'dance_floor'],
    fbItems: ['cocktail_hour', 'dinner', 'dessert', 'evening_snacks', 'after_party_room'],
    roomHire: 400,
    packageTotal: 17000.00,
    depositPaid: 8500.00,
    notes: 'Fri–Sun summer wedding weekend with premium F&B package',
    billingType: 'group',
    consumption: 9650.00,
  },
  {
    id: 'evt007',
    name: 'HSE Health & Safety Briefing',
    client: 'HSE',
    clientPhone: '049 437 1100',
    clientEmail: 'training@hse.ie',
    type: 'corporate',
    venue_id: 'annalee',
    date: '2026-04-23',
    startTime: '10:00',
    endTime: '12:30',
    guests: 22,
    stage: 'complete',
    setup: 'classroom',
    equipment: ['projector'],
    fbItems: ['morning_tea'],
    roomHire: 190,
    packageTotal: 450.00,
    depositPaid: 450.00,
    notes: 'Half-day rates applied. Completed on schedule.',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt008',
    name: 'HSE Clinical Supervision',
    client: 'HSE',
    clientPhone: '049 437 1100',
    clientEmail: 'training@hse.ie',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-04-30',
    startTime: '14:00',
    endTime: '16:00',
    guests: 10,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: [],
    fbItems: ['afternoon_tea'],
    roomHire: 170,
    packageTotal: 271.20,
    depositPaid: 0,
    notes: 'Smaller group meeting. Quote pending.',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt009',
    name: 'Holistic Fairs Ireland',
    client: 'Holistic Fairs Ireland',
    clientPhone: '086 234 5678',
    clientEmail: 'info@holisticfairs.ie',
    type: 'community',
    venue_id: 'new-bar',
    date: '2026-04-25',
    startTime: '10:00',
    endTime: '17:00',
    guests: 25,
    stage: 'complete',
    setup: 'banquet',
    equipment: [],
    fbItems: ['tea_coffee'],
    roomHire: 400,
    packageTotal: 400.00,
    depositPaid: 400.00,
    notes: 'Community event. Full day rate.',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt010',
    name: 'Bluecrest Health Consultation',
    client: 'Bluecrest Health',
    clientPhone: '0800 652 2173',
    clientEmail: 'venues@bluecresthealth.co.uk',
    type: 'corporate',
    venue_id: 'annalee',
    date: '2026-04-30',
    startTime: '13:00',
    endTime: '17:00',
    guests: 8,
    stage: 'deposit_paid',
    setup: 'boardroom',
    equipment: ['projector'],
    fbItems: ['afternoon_tea'],
    roomHire: 150,
    packageTotal: 150.00,
    depositPaid: 150.00,
    notes: 'Small group half-day session',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt011',
    name: 'Table Tennis Ireland Championship',
    client: 'Table Tennis Ireland',
    clientPhone: '01 456 7890',
    clientEmail: 'events@tabletennisireland.ie',
    type: 'community',
    venue_id: 'skeff-full',
    date: '2026-04-10',
    startTime: '08:00',
    endTime: '18:00',
    guests: 150,
    stage: 'complete',
    setup: 'theatre',
    equipment: ['tables', 'stage', 'sound_system', 'lighting'],
    fbItems: ['breakfast', 'morning_tea', 'lunch', 'afternoon_tea', 'evening_reception'],
    roomHire: 400,
    packageTotal: 8100.00,
    depositPaid: 8100.00,
    notes: 'Full day championship event. Multi-use space.',
    billingType: 'group',
    consumption: 7700.00,
  },
  {
    id: 'evt012',
    name: 'Birthday Party - The Smiths',
    client: 'John Smith',
    clientPhone: '087 456 1234',
    clientEmail: 'jsmith@email.com',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-05-02',
    startTime: '18:00',
    endTime: '22:00',
    guests: 30,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['sound_system'],
    fbItems: ['welcome_drinks', 'canapés', 'cake'],
    roomHire: 240,
    packageTotal: 450.00,
    depositPaid: 225.00,
    notes: '50th birthday celebration',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt013',
    name: 'Anniversary Dinner - The Walshes',
    client: 'Mary Walsh',
    clientPhone: '086 789 5432',
    clientEmail: 'mwalsh@email.com',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-05-10',
    startTime: '19:00',
    endTime: '23:00',
    guests: 25,
    stage: 'enquiry',
    setup: 'banquet',
    equipment: [],
    fbItems: ['dinner', 'dessert', 'wine'],
    roomHire: 240,
    packageTotal: null,
    depositPaid: 0,
    notes: 'Awaiting pricing confirmation',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt014',
    name: 'Corporate Dinner - TechStart Ltd',
    client: 'TechStart Ltd',
    clientPhone: '01 234 5678',
    clientEmail: 'events@techstart.ie',
    type: 'corporate',
    venue_id: 'skeff2',
    date: '2026-05-15',
    startTime: '18:30',
    endTime: '22:00',
    guests: 120,
    stage: 'quote_sent',
    setup: 'banquet',
    equipment: ['projector', 'sound_system'],
    fbItems: ['welcome_cocktail', 'dinner', 'dessert'],
    roomHire: 265,
    packageTotal: 1890.00,
    depositPaid: 0,
    notes: 'Waiting for client approval of quote',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt015',
    name: 'Music Night - Jazz Session',
    client: 'Local Jazz Club',
    clientPhone: '087 123 9999',
    clientEmail: 'info@localjazz.ie',
    type: 'music_night',
    venue_id: 'new-bar',
    date: '2026-05-22',
    startTime: '20:00',
    endTime: '23:30',
    guests: 80,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting'],
    fbItems: ['wine_selection', 'cheese_board'],
    roomHire: 300,
    packageTotal: 650.00,
    depositPaid: 325.00,
    notes: 'Live jazz band performing. Premium bar service.',
    billingType: 'group',
    consumption: 350.00,
  },
  {
    id: 'evt016',
    name: 'Communion Reception - The Byrnes',
    client: 'Mary Byrne',
    clientPhone: '085 234 5678',
    clientEmail: 'mbyrne@email.com',
    type: 'private_party',
    venue_id: 'foyer',
    date: '2026-05-30',
    startTime: '14:00',
    endTime: '17:00',
    guests: 60,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: ['tea_coffee', 'sandwiches', 'cake'],
    roomHire: 100,
    packageTotal: 340.00,
    depositPaid: 170.00,
    notes: 'Family celebration with buffet service',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt017',
    name: 'Table Booking - Reynards - 8 Covers',
    client: 'Michael Green',
    clientPhone: '087 345 6789',
    clientEmail: 'mgreen@email.com',
    type: 'restaurant_booking',
    venue_id: 'reynards',
    date: '2026-04-20',
    startTime: '19:30',
    endTime: '22:00',
    guests: 8,
    stage: 'complete',
    setup: 'table_service',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 320.00,
    depositPaid: 320.00,
    notes: 'Dinner reservation. À la carte menu.',
    billingType: 'per_cover',
    consumption: 320.00,
  },
  {
    id: 'evt018',
    name: 'Table Booking - R&R - 12 Covers',
    client: 'Sandra O\'Connor',
    clientPhone: '086 456 7890',
    clientEmail: 'soconnor@email.com',
    type: 'restaurant_booking',
    venue_id: 'randr',
    date: '2026-04-25',
    startTime: '20:00',
    endTime: '22:30',
    guests: 12,
    stage: 'confirmed',
    setup: 'table_service',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 480.00,
    depositPaid: 240.00,
    notes: 'Birthday group dinner',
    billingType: 'per_cover',
    consumption: null,
  },
  {
    id: 'evt019',
    name: 'Conference - Irish Retail Association',
    client: 'Irish Retail Association',
    clientPhone: '01 878 8888',
    clientEmail: 'events@ira.ie',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-06-05',
    startTime: '08:30',
    endTime: '17:30',
    guests: 280,
    stage: 'deposit_paid',
    setup: 'theatre',
    equipment: ['stage', 'projector', 'sound_system', 'lighting', 'breakout_rooms'],
    fbItems: ['breakfast', 'morning_break', 'lunch', 'afternoon_break', 'welcome_reception'],
    roomHire: 400,
    packageTotal: 5600.00,
    depositPaid: 2800.00,
    notes: 'Full day conference with multiple breakout sessions',
    billingType: 'group',
    consumption: 2800.00,
  },
  {
    id: 'evt020',
    name: 'Christening - The Dohertys',
    client: 'Patrick Doherty',
    clientPhone: '087 567 8901',
    clientEmail: 'pdoherty@email.com',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-06-14',
    startTime: '14:30',
    endTime: '17:30',
    guests: 35,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: ['tea_coffee', 'sandwiches', 'cake'],
    roomHire: 240,
    packageTotal: 380.00,
    depositPaid: 190.00,
    notes: 'Family celebration with light refreshments',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt021',
    name: 'Training Workshop - Finance Ireland',
    client: 'Finance Ireland',
    clientPhone: '01 234 5000',
    clientEmail: 'training@financeireland.ie',
    type: 'corporate',
    venue_id: 'skeff1',
    date: '2026-06-18',
    startTime: '09:00',
    endTime: '16:30',
    guests: 65,
    stage: 'confirmed',
    setup: 'classroom',
    equipment: ['projector', 'flipchart', 'sound_system'],
    fbItems: ['morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 265,
    packageTotal: 680.00,
    depositPaid: 340.00,
    notes: 'Professional development training',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt022',
    name: 'Charity Auction Gala - Local Hospice',
    client: 'Local Hospice',
    clientPhone: '049 437 9999',
    clientEmail: 'events@localhospice.ie',
    type: 'charity',
    venue_id: 'skeff-full',
    date: '2026-06-22',
    startTime: '19:00',
    endTime: '23:00',
    guests: 200,
    stage: 'quote_sent',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting', 'auction_setup'],
    fbItems: ['cocktail_hour', 'dinner', 'dessert'],
    roomHire: 400,
    packageTotal: 4200.00,
    depositPaid: 0,
    notes: 'Charity event - awaiting confirmation',
    billingType: 'group',
    consumption: null,
  },
  {
    id: 'evt023',
    name: 'Funeral Reception - The Murphys',
    client: 'Siobhan Murphy',
    clientPhone: '087 678 9012',
    clientEmail: 'smurphy@email.com',
    type: 'private_party',
    venue_id: 'foyer',
    date: '2026-04-05',
    startTime: '13:00',
    endTime: '16:30',
    guests: 75,
    stage: 'complete',
    setup: 'banquet',
    equipment: [],
    fbItems: ['tea_coffee', 'sandwiches', 'cake'],
    roomHire: 100,
    packageTotal: 450.00,
    depositPaid: 450.00,
    notes: 'Memorial gathering with light refreshments',
    billingType: 'group',
    consumption: null,
  },

  // ===== WEEK OF APRIL 20-26, 2026 =====

  // --- MONDAY 20 APRIL ---
  {
    id: 'evt024',
    name: 'Cavan County Council Staff Training',
    client: 'Cavan County Council',
    clientPhone: '049 437 8300',
    clientEmail: 'training@cavancoco.ie',
    type: 'corporate',
    venue_id: 'skeff1',
    date: '2026-04-20',
    startTime: '09:00',
    endTime: '17:00',
    guests: 60,
    stage: 'deposit_paid',
    setup: 'classroom',
    equipment: ['projector', 'flipchart', 'sound_system'],
    fbItems: ['morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 265,
    packageTotal: 1680.00,
    depositPaid: 840.00,
    notes: 'Annual mandatory H&S training day. Lunch: chicken or vegetarian option. 3 flipcharts needed. Contact: Brenda Reilly.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '4 vegetarian, 2 gluten-free',
    setupRequirements: 'Classroom layout with centre aisle. Registration desk at entrance.',
    menuNotes: 'Chicken supreme or stuffed pepper (veg). Tea/coffee x2 with scones AM, biscuits PM.',
    contractSigned: true,
    contractDate: '2026-03-15',
  },
  {
    id: 'evt025',
    name: 'Solicitors Board Meeting',
    client: 'Maguire & Patterson Solicitors',
    clientPhone: '049 433 1100',
    clientEmail: 'reception@maguirepatterson.ie',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-04-20',
    startTime: '14:00',
    endTime: '17:00',
    guests: 10,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: ['projector'],
    fbItems: ['afternoon_tea'],
    roomHire: 170,
    packageTotal: 295.00,
    depositPaid: 147.50,
    notes: 'Quarterly partners meeting. Water jugs on table. Strictly private - no interruptions.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '1 dairy-free',
    setupRequirements: 'Boardroom with notepads and pens. HDMI for laptop. Whiteboard.',
    menuNotes: 'Premium afternoon tea: finger sandwiches, scones, pastries. Dairy-free alternative for 1.',
    contractSigned: true,
    contractDate: '2026-04-01',
  },
  {
    id: 'evt026',
    name: '21st Birthday - Aoife Brennan',
    client: 'Declan Brennan',
    clientPhone: '086 345 2211',
    clientEmail: 'declanbrennan@gmail.com',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-04-20',
    startTime: '19:00',
    endTime: '23:30',
    guests: 35,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['sound_system', 'lighting'],
    fbItems: ['welcome_drinks', 'dinner', 'dessert', 'cake'],
    roomHire: 240,
    packageTotal: 1575.00,
    depositPaid: 787.50,
    notes: 'Surprise 21st for daughter Aoife. Band arriving at 9pm - need power near stage area. Cake being delivered by Dolce Vita at 5pm.',
    billingType: 'group',
    consumption: 650.00,
    dietaryRequirements: '3 vegetarian, 1 nut allergy',
    setupRequirements: 'Round tables x4, top table for 8. Balloon arch by entrance. Photo booth corner.',
    menuNotes: '4-course set menu: soup, chicken or salmon, pavlova. Kids menu x3. Outside cake to be served as dessert.',
    contractSigned: true,
    contractDate: '2026-03-20',
  },
  {
    id: 'evt027',
    name: 'Gin Tasting Evening',
    client: 'Cavan Gin Society',
    clientPhone: '087 222 3344',
    clientEmail: 'info@cavanginsociety.ie',
    type: 'community',
    venue_id: 'new-bar',
    date: '2026-04-20',
    startTime: '19:30',
    endTime: '22:30',
    guests: 28,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['sound_system'],
    fbItems: ['canapes', 'cheese_board'],
    roomHire: 300,
    packageTotal: 840.00,
    depositPaid: 420.00,
    notes: 'Monthly tasting event. Gin supplied by society. We provide glassware, ice, mixers, and food. Cash bar for additional drinks.',
    billingType: 'group',
    consumption: 540.00,
    dietaryRequirements: '2 vegetarian',
    setupRequirements: 'Tasting stations x5 around the room. High tables. Mood lighting.',
    menuNotes: 'Paired canapés for each gin. Cheese board for grazing.',
    contractSigned: true,
    contractDate: '2026-01-10',
  },

  // --- TUESDAY 21 APRIL ---
  {
    id: 'evt028',
    name: 'AIB Regional Sales Conference',
    client: 'AIB Group',
    clientPhone: '01 660 0311',
    clientEmail: 'events@aib.ie',
    type: 'corporate',
    venue_id: 'skeff2',
    date: '2026-04-21',
    startTime: '08:30',
    endTime: '17:30',
    guests: 120,
    stage: 'deposit_paid',
    setup: 'theatre',
    equipment: ['projector', 'sound_system', 'stage', 'lighting'],
    fbItems: ['breakfast', 'morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 265,
    packageTotal: 4200.00,
    depositPaid: 2100.00,
    notes: 'Annual regional sales conference. 3 keynote speakers. Breakout sessions after lunch in Corrick + Annalee. AV tech on-site all day.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '8 vegetarian, 3 vegan, 2 coeliac',
    setupRequirements: 'Theatre with stage. 2x handheld mics, 1 lapel mic. Lectern. Large screen.',
    menuNotes: 'Breakfast rolls on arrival. Lunch: carvery style. Morning: scones/pastries. Afternoon: tray bakes.',
    contractSigned: true,
    contractDate: '2026-02-20',
  },
  {
    id: 'evt029',
    name: 'Tusla Case Review Meeting',
    client: 'Tusla Child & Family Agency',
    clientPhone: '049 437 8900',
    clientEmail: 'bookings@tusla.ie',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-04-21',
    startTime: '10:00',
    endTime: '13:00',
    guests: 8,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: [],
    fbItems: ['morning_tea'],
    roomHire: 170,
    packageTotal: 215.00,
    depositPaid: 0,
    notes: 'Confidential meeting. Room must be secured - no access for non-attendees. Regular booking.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '',
    setupRequirements: 'Boardroom. Ensure door closes fully. Water on table.',
    menuNotes: 'Tea/coffee on arrival with biscuits.',
    contractSigned: false,
    contractDate: '',
  },

  // --- WEDNESDAY 22 APRIL ---
  {
    id: 'evt030',
    name: 'Cavan LEO Start Your Business Workshop',
    client: 'Cavan Local Enterprise Office',
    clientPhone: '049 437 7208',
    clientEmail: 'info@leo.cavancoco.ie',
    type: 'corporate',
    venue_id: 'annalee',
    date: '2026-04-22',
    startTime: '09:30',
    endTime: '13:00',
    guests: 18,
    stage: 'deposit_paid',
    setup: 'ushape',
    equipment: ['projector', 'flipchart'],
    fbItems: ['morning_tea', 'lunch'],
    roomHire: 190,
    packageTotal: 540.00,
    depositPaid: 270.00,
    notes: 'Part of a 6-week programme. Facilitator: Karen Doyle. Same setup every Wednesday.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '2 vegetarian, 1 halal',
    setupRequirements: 'U-shape for 18. Projector screen at open end. Flipchart beside screen.',
    menuNotes: 'Morning: tea/coffee with scones. Lunch: soup + sandwich platter with wraps.',
    contractSigned: true,
    contractDate: '2026-03-01',
  },
  {
    id: 'evt031',
    name: 'Lakeland Dairies AGM',
    client: 'Lakeland Dairies',
    clientPhone: '042 966 1022',
    clientEmail: 'agm@lakeland.ie',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-04-22',
    startTime: '10:00',
    endTime: '16:00',
    guests: 250,
    stage: 'deposit_paid',
    setup: 'theatre',
    equipment: ['projector', 'sound_system', 'stage', 'lighting'],
    fbItems: ['morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 400,
    packageTotal: 6250.00,
    depositPaid: 3125.00,
    notes: 'Annual General Meeting. Board at top table on stage. Registration desk needed. Press may attend - reserved seating front row.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '15 vegetarian, 5 gluten-free',
    setupRequirements: 'Theatre 250 seats. Stage with top table for 12. Lectern with mic. 2 roving mics for Q&A. Registration desk at main entrance.',
    menuNotes: 'Morning: tea/coffee with pastries. Lunch: 3-course sit-down (soup, beef or fish, dessert). Afternoon: tea/coffee.',
    contractSigned: true,
    contractDate: '2026-01-15',
  },

  // --- THURSDAY 23 APRIL ---
  // (evt007 already exists: HSE Health & Safety in Annalee - complete)
  {
    id: 'evt032',
    name: 'Rotary Club Charity Luncheon',
    client: 'Cavan Rotary Club',
    clientPhone: '087 654 3210',
    clientEmail: 'secretary@cavanrotary.ie',
    type: 'charity',
    venue_id: 'skeff1',
    date: '2026-04-23',
    startTime: '12:00',
    endTime: '15:30',
    guests: 85,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['sound_system'],
    fbItems: ['welcome_drinks', 'lunch', 'dessert'],
    roomHire: 200,
    packageTotal: 2550.00,
    depositPaid: 1275.00,
    notes: 'Annual charity luncheon supporting local charities. Guest speaker after main course. Raffle during dessert. Top table for 10.',
    billingType: 'group',
    consumption: 1200.00,
    dietaryRequirements: '6 vegetarian, 2 coeliac, 1 vegan',
    setupRequirements: 'Round tables of 10. Top table for 10 on raised platform. Lectern with mic.',
    menuNotes: '3-course: Seafood chowder, roast beef or pan-fried salmon, chocolate fondant. Wine service at tables. Pre-lunch drinks reception.',
    contractSigned: true,
    contractDate: '2026-02-10',
  },
  {
    id: 'evt033',
    name: 'Retirement Party - Seamus Maguire',
    client: 'Brenda Maguire',
    clientPhone: '086 112 3344',
    clientEmail: 'brenda.maguire@hotmail.com',
    type: 'private_party',
    venue_id: 'foyer',
    date: '2026-04-23',
    startTime: '19:00',
    endTime: '23:00',
    guests: 65,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['sound_system'],
    fbItems: ['welcome_drinks', 'dinner', 'dessert', 'evening_snacks'],
    roomHire: 100,
    packageTotal: 1950.00,
    depositPaid: 975.00,
    notes: 'Seamus retiring after 40 years with ESB. Speeches at 8pm. Photo slideshow to run on loop. Band: The Boomtowns from 10pm.',
    billingType: 'group',
    consumption: 750.00,
    dietaryRequirements: '5 vegetarian, 1 dairy-free',
    setupRequirements: 'Rectangular tables. Top table for 12. Screen for slideshow. Dance floor area near band.',
    menuNotes: '4-course: soup, beef or chicken, trifle + cheese board. Finger food at 10pm. Cash bar all evening.',
    contractSigned: true,
    contractDate: '2026-03-05',
  },

  // --- FRIDAY 24 APRIL ---
  {
    id: 'evt034',
    name: 'O\'Reilly & Flanagan Wedding Rehearsal Dinner',
    client: 'Niamh O\'Reilly & Sean Flanagan',
    clientPhone: '085 998 7766',
    clientEmail: 'niamhsean2026@gmail.com',
    type: 'wedding',
    venue_id: 'skeff2',
    date: '2026-04-24',
    startTime: '18:30',
    endTime: '22:30',
    guests: 45,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['sound_system', 'lighting'],
    fbItems: ['welcome_cocktail', 'dinner', 'dessert', 'wine_selection'],
    roomHire: 265,
    packageTotal: 2475.00,
    depositPaid: 1237.50,
    notes: 'Rehearsal dinner night before wedding (wedding is Apr 25 in Skeff Full). Intimate family dinner. Speeches from best man and maid of honour.',
    billingType: 'group',
    consumption: 1100.00,
    dietaryRequirements: '4 vegetarian, 1 nut allergy, 2 coeliac',
    setupRequirements: 'Long banquet table for 45. Candles and greenery as centrepieces. Fairy lights.',
    menuNotes: 'Sharing platters starter, beef fillet main, selection of desserts. Wine pairing per course.',
    contractSigned: true,
    contractDate: '2026-01-20',
  },
  {
    id: 'evt035',
    name: 'Trad Session - Friday Night Live',
    client: 'Errigal Events Internal',
    clientPhone: '049 555 6901',
    clientEmail: 'events@errigalhotel.com',
    type: 'music_night',
    venue_id: 'new-bar',
    date: '2026-04-24',
    startTime: '21:00',
    endTime: '23:30',
    guests: 30,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['sound_system', 'lighting'],
    fbItems: ['cheese_board'],
    roomHire: 0,
    packageTotal: 350.00,
    depositPaid: 350.00,
    notes: 'Weekly trad session. Band: The Lough Oughter Boys. No room hire - internal event. Band fee €250 + food.',
    billingType: 'group',
    consumption: 350.00,
    dietaryRequirements: '',
    setupRequirements: 'Clear corner for musicians. 4 chairs, 2 mic stands. Low lighting.',
    menuNotes: 'Complimentary cheese board for musicians. Bar menu available for guests.',
    contractSigned: false,
    contractDate: '',
  },
  {
    id: 'evt036',
    name: 'IFA Cavan Information Evening',
    client: 'IFA Cavan',
    clientPhone: '049 436 1200',
    clientEmail: 'cavan@ifa.ie',
    type: 'corporate',
    venue_id: 'annalee',
    date: '2026-04-24',
    startTime: '19:00',
    endTime: '21:30',
    guests: 30,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['projector', 'sound_system'],
    fbItems: ['tea_coffee'],
    roomHire: 190,
    packageTotal: 320.00,
    depositPaid: 160.00,
    notes: 'Farmer information session on new CAP reforms. Guest speaker from DAFM. Q&A session. Tea/coffee on arrival.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '',
    setupRequirements: 'Theatre for 30. Screen at front. Lectern. Handheld mic for Q&A.',
    menuNotes: 'Tea/coffee with biscuits on arrival only.',
    contractSigned: false,
    contractDate: '',
  },

  // --- SATURDAY 25 APRIL ---
  // (evt009 already exists: Holistic Fairs in New Bar - complete)
  // (evt018 already exists: Table Booking R&R - confirmed)
  {
    id: 'evt037',
    name: 'O\'Reilly & Flanagan Wedding Reception',
    client: 'Niamh O\'Reilly & Sean Flanagan',
    clientPhone: '085 998 7766',
    clientEmail: 'niamhsean2026@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-04-25',
    startTime: '16:00',
    endTime: '23:30',
    guests: 210,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['stage', 'sound_system', 'lighting', 'dance_floor'],
    fbItems: ['cocktail_hour', 'dinner', 'dessert', 'evening_snacks', 'wine_selection', 'cake'],
    roomHire: 400,
    packageTotal: 15750.00,
    depositPaid: 7875.00,
    notes: 'Wedding of the year. Ceremony at St Patrick\'s Cavan at 2pm. Arrive hotel 4pm. Drinks reception in Foyer. Band: The Conquerors 9:30pm. DJ until 2am. Photographer: Brian Hughes. Videographer: Alan Farrell. Florist delivering at 10am.',
    billingType: 'group',
    consumption: 8400.00,
    dietaryRequirements: '12 vegetarian, 4 vegan, 3 coeliac, 2 nut allergy, 1 shellfish allergy',
    setupRequirements: 'Full suite banquet. Top table 14, round tables 10s. Chair covers white with sage green sashes. Centrepieces by florist. Cake table left of top table. Gift table at entrance. Seating chart easel. Stage for band. Dance floor centre.',
    menuNotes: '5-course: amuse bouche, soup, choice of beef/salmon/mushroom risotto, trio of desserts, tea/coffee + petit fours. Evening: bacon/sausage sandwiches + pizza slices at 11pm. Kids meal x12.',
    contractSigned: true,
    contractDate: '2025-11-15',
  },
  {
    id: 'evt038',
    name: 'First Communion - The Bradys',
    client: 'Orla Brady',
    clientPhone: '087 334 5566',
    clientEmail: 'orlabrady@gmail.com',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-04-25',
    startTime: '14:00',
    endTime: '17:00',
    guests: 30,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: ['tea_coffee', 'sandwiches', 'cake'],
    roomHire: 190,
    packageTotal: 480.00,
    depositPaid: 240.00,
    notes: 'Communion party for Sophie Brady. Family celebration. Cake being brought by family. Balloons permitted.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '2 vegetarian, 1 coeliac',
    setupRequirements: 'Banquet for 30. Table for presents and cards. Space for kids to run around.',
    menuNotes: 'Afternoon tea: finger sandwiches, scones, tray bakes. Juice for children. Family providing own cake.',
    contractSigned: true,
    contractDate: '2026-03-10',
  },

  // --- SUNDAY 26 APRIL ---
  {
    id: 'evt039',
    name: 'Sunday Brunch - Vintage Car Club',
    client: 'Cavan Vintage Car Club',
    clientPhone: '087 555 6677',
    clientEmail: 'info@cavanvintagecc.ie',
    type: 'community',
    venue_id: 'foyer',
    date: '2026-04-26',
    startTime: '11:00',
    endTime: '14:00',
    guests: 45,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: ['breakfast', 'tea_coffee'],
    roomHire: 100,
    packageTotal: 675.00,
    depositPaid: 337.50,
    notes: 'Monthly meet-up. Cars parked in front car park for display. Brunch followed by a drive to Killykeen Forest. Photographer welcome.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '3 vegetarian',
    setupRequirements: 'Banquet for 45. Tables by the windows overlooking car park if possible.',
    menuNotes: 'Full Irish brunch: eggs, bacon, sausage, toast, pancakes, fruit, pastries, juice, tea/coffee.',
    contractSigned: false,
    contractDate: '',
  },
  {
    id: 'evt040',
    name: 'Golden Wedding Anniversary - The Sheridans',
    client: 'Colm Sheridan',
    clientPhone: '049 433 2255',
    clientEmail: 'colmsheridan@eircom.net',
    type: 'private_party',
    venue_id: 'annalee',
    date: '2026-04-26',
    startTime: '15:00',
    endTime: '20:00',
    guests: 35,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: ['sound_system'],
    fbItems: ['welcome_drinks', 'afternoon_tea', 'dinner', 'cake'],
    roomHire: 240,
    packageTotal: 1260.00,
    depositPaid: 630.00,
    notes: '50th wedding anniversary for Colm & Maureen Sheridan. Family from UK and US travelling. Speeches at 5pm. Accordion player 6-8pm.',
    billingType: 'group',
    consumption: 420.00,
    dietaryRequirements: '4 vegetarian, 1 vegan',
    setupRequirements: 'Banquet for 35. Top table for 6. Gold tablecloths if possible. Photo display corner.',
    menuNotes: 'Prosecco on arrival. Afternoon tea first, then 3-course dinner at 6pm: prawn cocktail, roast lamb, apple tart. Family providing cake.',
    contractSigned: true,
    contractDate: '2026-03-01',
  },
  {
    id: 'evt041',
    name: 'Yoga & Wellness Morning',
    client: 'Mind Body Cavan',
    clientPhone: '085 667 8899',
    clientEmail: 'hello@mindbodycavan.ie',
    type: 'community',
    venue_id: 'skeff1',
    date: '2026-04-26',
    startTime: '09:00',
    endTime: '12:00',
    guests: 40,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: ['morning_tea'],
    roomHire: 200,
    packageTotal: 480.00,
    depositPaid: 240.00,
    notes: 'Wellness morning: 1hr yoga, 1hr meditation, then tea. Mats brought by participants. Floor must be clean and clear.',
    billingType: 'group',
    consumption: null,
    dietaryRequirements: '10 vegan, 5 gluten-free',
    setupRequirements: 'All chairs removed. Clear floor space. Dimmed lighting. Bluetooth speaker for instructor.',
    menuNotes: 'Herbal tea, fruit salad, granola pots, smoothie shots. No dairy. Mostly vegan.',
    contractSigned: false,
    contractDate: '',
  },
];

export const SAMPLE_CLIENTS = [
  {
    id: 1,
    name: 'Michael Donohue',
    company: 'Abbott',
    phone: '087 123 4567',
    email: 'm.donohue@abbott.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 603.50,
    lastEvent: '2026-04-08',
  },
  {
    id: 2,
    name: 'Tusla Child & Family Agency',
    company: 'Tusla',
    phone: '049 437 8900',
    email: 'bookings@tusla.ie',
    tag: 'corporate',
    totalEvents: 5,
    totalRevenue: 2076.00,
    lastEvent: '2026-04-29',
  },
  {
    id: 3,
    name: 'Kellie Ann',
    company: 'NOWGROUP',
    phone: '048 7126 0026',
    email: 'kellie.ann@nowgroup.org',
    tag: 'corporate',
    totalEvents: 4,
    totalRevenue: 812.00,
    lastEvent: '2026-04-28',
  },
  {
    id: 4,
    name: 'Parkinsons Ireland',
    company: 'Parkinsons Ireland',
    phone: '01 872 2234',
    email: 'events@parkinsons.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 3370.00,
    lastEvent: '2026-04-17',
  },
  {
    id: 5,
    name: 'Sarah & James McNally',
    company: '',
    phone: '086 789 0123',
    email: 'sarahmcnally@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 13500.00,
    lastEvent: '2026-06-20',
  },
  {
    id: 6,
    name: 'Emma & Ciaran O\'Brien',
    company: '',
    phone: '085 456 7890',
    email: 'emmaobrien@outlook.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 17000.00,
    lastEvent: '2026-08-15',
  },
  {
    id: 7,
    name: 'HSE',
    company: 'HSE',
    phone: '049 437 1100',
    email: 'training@hse.ie',
    tag: 'corporate',
    totalEvents: 2,
    totalRevenue: 1221.20,
    lastEvent: '2026-04-23',
  },
  {
    id: 8,
    name: 'Holistic Fairs Ireland',
    company: 'Holistic Fairs Ireland',
    phone: '086 234 5678',
    email: 'info@holisticfairs.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 400.00,
    lastEvent: '2026-04-25',
  },
  {
    id: 9,
    name: 'Bluecrest Health',
    company: 'Bluecrest Health',
    phone: '0800 652 2173',
    email: 'venues@bluecresthealth.co.uk',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 150.00,
    lastEvent: '2026-04-30',
  },
  {
    id: 10,
    name: 'Table Tennis Ireland',
    company: 'Table Tennis Ireland',
    phone: '01 456 7890',
    email: 'events@tabletennisireland.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 8100.00,
    lastEvent: '2026-04-10',
  },
  {
    id: 11,
    name: 'Cavan County Council',
    company: 'Cavan County Council',
    phone: '049 437 8300',
    email: 'training@cavancoco.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 1680.00,
    lastEvent: '2026-04-20',
  },
  {
    id: 12,
    name: 'Maguire & Patterson Solicitors',
    company: 'Maguire & Patterson',
    phone: '049 433 1100',
    email: 'reception@maguirepatterson.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 295.00,
    lastEvent: '2026-04-20',
  },
  {
    id: 13,
    name: 'Declan Brennan',
    company: '',
    phone: '086 345 2211',
    email: 'declanbrennan@gmail.com',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 1575.00,
    lastEvent: '2026-04-20',
  },
  {
    id: 14,
    name: 'Cavan Gin Society',
    company: 'Cavan Gin Society',
    phone: '087 222 3344',
    email: 'info@cavanginsociety.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 840.00,
    lastEvent: '2026-04-20',
  },
  {
    id: 15,
    name: 'AIB Group',
    company: 'AIB',
    phone: '01 660 0311',
    email: 'events@aib.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 4200.00,
    lastEvent: '2026-04-21',
  },
  {
    id: 16,
    name: 'Cavan LEO',
    company: 'Local Enterprise Office',
    phone: '049 437 7208',
    email: 'info@leo.cavancoco.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 540.00,
    lastEvent: '2026-04-22',
  },
  {
    id: 17,
    name: 'Lakeland Dairies',
    company: 'Lakeland Dairies',
    phone: '042 966 1022',
    email: 'agm@lakeland.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 6250.00,
    lastEvent: '2026-04-22',
  },
  {
    id: 18,
    name: 'Cavan Rotary Club',
    company: 'Rotary International',
    phone: '087 654 3210',
    email: 'secretary@cavanrotary.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 2550.00,
    lastEvent: '2026-04-23',
  },
  {
    id: 19,
    name: 'Brenda Maguire',
    company: '',
    phone: '086 112 3344',
    email: 'brenda.maguire@hotmail.com',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 1950.00,
    lastEvent: '2026-04-23',
  },
  {
    id: 20,
    name: 'Niamh O\'Reilly & Sean Flanagan',
    company: '',
    phone: '085 998 7766',
    email: 'niamhsean2026@gmail.com',
    tag: 'wedding',
    totalEvents: 2,
    totalRevenue: 18225.00,
    lastEvent: '2026-04-25',
  },
  {
    id: 21,
    name: 'Orla Brady',
    company: '',
    phone: '087 334 5566',
    email: 'orlabrady@gmail.com',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 480.00,
    lastEvent: '2026-04-25',
  },
  {
    id: 22,
    name: 'Cavan Vintage Car Club',
    company: 'Cavan Vintage Car Club',
    phone: '087 555 6677',
    email: 'info@cavanvintagecc.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 675.00,
    lastEvent: '2026-04-26',
  },
  {
    id: 23,
    name: 'Colm Sheridan',
    company: '',
    phone: '049 433 2255',
    email: 'colmsheridan@eircom.net',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 1260.00,
    lastEvent: '2026-04-26',
  },
  {
    id: 24,
    name: 'IFA Cavan',
    company: 'IFA',
    phone: '049 436 1200',
    email: 'cavan@ifa.ie',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 320.00,
    lastEvent: '2026-04-24',
  },
  {
    id: 25,
    name: 'Mind Body Cavan',
    company: 'Mind Body Cavan',
    phone: '085 667 8899',
    email: 'hello@mindbodycavan.ie',
    tag: 'community',
    totalEvents: 1,
    totalRevenue: 480.00,
    lastEvent: '2026-04-26',
  },
];

export const EMAIL_TEMPLATES_EVENTS = [
  {
    id: 'enquiry_receipt',
    name: 'Enquiry Receipt',
    stage: 'enquiry',
    enabled: true,
    subject: 'Thank you for your enquiry - Errigal Country House Hotel',
    body: 'Dear {CLIENT_NAME},\n\nThank you for your interest in hosting your event at Errigal Country House Hotel. We have received your enquiry for {EVENT_NAME} on {EVENT_DATE} and are delighted to assist you.\n\nOur events team will review your requirements and be in touch within 24 hours with information, availability, and pricing.\n\nIn the meantime, please don\'t hesitate to contact us if you have any questions.\n\nWarm regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'quote_sent',
    name: 'Quote Sent',
    stage: 'quote_sent',
    enabled: true,
    subject: 'Your event quote for {EVENT_NAME} - Errigal Events',
    body: 'Dear {CLIENT_NAME},\n\nPlease find below the details of your personalised quote for {EVENT_NAME} on {EVENT_DATE}.\n\nVenue: {VENUE_NAME}\nGuests: {GUEST_COUNT}\nPackage Total: {PACKAGE_TOTAL}\n\nThis quote is valid for 14 days. To confirm your booking, a deposit of {DEPOSIT_AMOUNT} is required.\n\nWe would be happy to discuss any adjustments to suit your needs.\n\nKind regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'booking_confirmed',
    name: 'Booking Confirmed',
    stage: 'confirmed',
    enabled: true,
    subject: 'Your booking is confirmed - {EVENT_NAME}',
    body: 'Dear {CLIENT_NAME},\n\nGreat news! Your booking for {EVENT_NAME} on {EVENT_DATE} at {VENUE_NAME} has been confirmed.\n\nBooking Details:\n- Date: {EVENT_DATE}\n- Venue: {VENUE_NAME}\n- Guests: {GUEST_COUNT}\n- Package Total: {PACKAGE_TOTAL}\n\nA deposit of {DEPOSIT_AMOUNT} is due to secure your booking. We will be in touch closer to the date to confirm final arrangements.\n\nWe look forward to hosting your event.\n\nWarm regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'deposit_received',
    name: 'Deposit Received',
    stage: 'deposit_paid',
    enabled: true,
    subject: 'Deposit received - {EVENT_NAME}',
    body: 'Dear {CLIENT_NAME},\n\nThank you for your deposit payment of {DEPOSIT_AMOUNT} for {EVENT_NAME} on {EVENT_DATE}. Your booking is now fully secured.\n\nWe will be in touch in the weeks leading up to your event to finalise all the details.\n\nKind regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'deposit_reminder',
    name: 'Deposit Reminder',
    stage: 'confirmed',
    enabled: true,
    subject: 'Deposit payment reminder - {EVENT_NAME}',
    body: 'Dear {CLIENT_NAME},\n\nThis is a friendly reminder that your deposit payment of {DEPOSIT_AMOUNT} for {EVENT_NAME} on {EVENT_DATE} is now due.\n\nTo secure your booking, please arrange payment at your earliest convenience. If you have already made payment, please disregard this message.\n\nKind regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'event_reminder',
    name: 'Event Reminder',
    stage: 'deposit_paid',
    enabled: true,
    subject: 'Your event is coming up - {EVENT_NAME}',
    body: 'Dear {CLIENT_NAME},\n\nJust a reminder that your event {EVENT_NAME} is coming up on {EVENT_DATE} at {VENUE_NAME}.\n\nIf you have any last-minute requirements or changes, please let us know as soon as possible so we can accommodate them.\n\nWe look forward to welcoming you and your guests.\n\nWarm regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'final_invoice',
    name: 'Final Invoice',
    stage: 'deposit_paid',
    enabled: true,
    subject: 'Final invoice for {EVENT_NAME} - Errigal Events',
    body: 'Dear {CLIENT_NAME},\n\nPlease find your final invoice for {EVENT_NAME} on {EVENT_DATE}.\n\nPackage Total: {PACKAGE_TOTAL}\nDeposit Paid: {DEPOSIT_AMOUNT}\nBalance Due: {BALANCE_DUE}\n\nPayment is due 7 days before your event. Please arrange a bank transfer or contact us to arrange payment.\n\nThank you for choosing Errigal Country House Hotel.\n\nKind regards,\nThe Events Team\nErrigal Country House Hotel',
  },
  {
    id: 'post_event_followup',
    name: 'Post-Event Follow Up',
    stage: 'complete',
    enabled: true,
    subject: 'Thank you - {EVENT_NAME}',
    body: 'Dear {CLIENT_NAME},\n\nThank you for hosting {EVENT_NAME} with us at Errigal Country House Hotel. We hope your event was a wonderful success.\n\nWe would love to hear your feedback and would be delighted to assist with any future events you may be planning.\n\nWarm regards,\nThe Events Team\nErrigal Country House Hotel',
  },
];

export const EMAIL_TEMPLATES_WEDDINGS = [
  {
    id: 'wedding_enquiry_receipt',
    name: 'Wedding Enquiry Receipt',
    stage: 'enquiry',
    enabled: true,
    subject: 'Congratulations on your engagement - Errigal Country House Hotel',
    body: 'Dear {CLIENT_NAME},\n\nCongratulations on your upcoming wedding! Thank you for considering Errigal Country House Hotel as your wedding venue.\n\nWe would love to learn more about your vision for your special day. Our wedding coordinator will be in touch shortly to arrange a complimentary consultation and show-around of our facilities.\n\nDate of Interest: {EVENT_DATE}\nEstimated Guests: {GUEST_COUNT}\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_consultation',
    name: 'Wedding Consultation',
    stage: 'enquiry',
    enabled: true,
    subject: 'Your wedding consultation at Errigal',
    body: 'Dear {CLIENT_NAME},\n\nWe are delighted to offer you a complimentary wedding consultation with our dedicated wedding team.\n\nDuring your visit, we will show you our stunning {VENUE_NAME}, discuss your vision, and explore how we can make your day truly special.\n\nPlease let us know your preferred dates and times for the consultation.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_proposal',
    name: 'Wedding Proposal',
    stage: 'quote_sent',
    enabled: true,
    subject: 'Your bespoke wedding proposal - Errigal',
    body: 'Dear {CLIENT_NAME},\n\nThank you for visiting Errigal Country House Hotel. Please find your personalised wedding proposal below.\n\nWedding Date: {EVENT_DATE}\nVenue: {VENUE_NAME}\nGuests: {GUEST_COUNT}\nPackage Total: {PACKAGE_TOTAL}\n\nOur team has crafted this package to reflect your vision and budget. We are happy to discuss any adjustments.\n\nTo secure your date, a deposit of {DEPOSIT_AMOUNT} is required.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_confirmed',
    name: 'Wedding Confirmed',
    stage: 'confirmed',
    enabled: true,
    subject: 'Your wedding is confirmed - {EVENT_DATE}',
    body: 'Dear {CLIENT_NAME},\n\nWe are thrilled to confirm your wedding at Errigal Country House Hotel on {EVENT_DATE}!\n\nYour date is now secured and our wedding team will guide you through every step of the planning process. We will be in touch to arrange your next planning meeting.\n\nCongratulations again, and we look forward to helping create your perfect day.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_deposit_reminder',
    name: 'Wedding Deposit Reminder',
    stage: 'confirmed',
    enabled: true,
    subject: 'Secure your wedding date - {EVENT_DATE}',
    body: 'Dear {CLIENT_NAME},\n\nA friendly reminder that to secure your wedding date of {EVENT_DATE}, a deposit of {DEPOSIT_AMOUNT} is required.\n\nWe would hate for you to miss out on your preferred date, so please arrange payment at your earliest convenience.\n\nIf you have any questions about payment options, please don\'t hesitate to get in touch.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_final_details',
    name: 'Wedding Final Details',
    stage: 'deposit_paid',
    enabled: true,
    subject: 'Final details for your wedding - {EVENT_DATE}',
    body: 'Dear {CLIENT_NAME},\n\nAs your wedding date of {EVENT_DATE} approaches, we need to confirm some final details:\n\n- Final guest numbers\n- Menu selections and dietary requirements\n- Table plan and seating arrangements\n- Ceremony and reception timings\n- Styling and decoration preferences\n- Any special requests\n\nPlease provide these details at least 14 days before your wedding to ensure everything is perfect.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
  {
    id: 'wedding_followup',
    name: 'Wedding Follow Up',
    stage: 'complete',
    enabled: true,
    subject: 'Congratulations Mr & Mrs! - Errigal Country House Hotel',
    body: 'Dear {CLIENT_NAME},\n\nCongratulations on your wedding! We hope your day at Errigal Country House Hotel was everything you dreamed of and more.\n\nWe would love to see any photos from your special day, and we\'d be honoured if you would share your experience with other couples considering Errigal for their wedding.\n\nThank you for trusting us with your most important day. We wish you a lifetime of happiness together.\n\nWarm regards,\nThe Wedding Team\nErrigal Country House Hotel',
  },
];

export const INTEGRATIONS = [
  {
    id: 'tevalis_pos',
    name: 'Tevalis POS',
    description: 'Point of Sale system integration for tracking consumption and payments',
    status: 'pending',
    icon: 'shopping-cart',
  },
  {
    id: 'clock_pms',
    name: 'Clock PMS',
    description: 'Property Management System integration for room management',
    status: 'planned',
    icon: 'building',
  },
];

export const SAMPLE_PAYMENTS = [
  {
    id: 'pmt001',
    event_id: 'evt001',
    amount: 603.50,
    payment_date: '2026-04-08',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-001',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt002',
    event_id: 'evt002',
    amount: 520.00,
    payment_date: '2026-04-09',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-002',
    notes: 'Full payment',
    status: 'completed',
  },
  {
    id: 'pmt003',
    event_id: 'evt004',
    amount: 1685.00,
    payment_date: '2026-04-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-003',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt004',
    event_id: 'evt005',
    amount: 6750.00,
    payment_date: '2026-05-20',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-004',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt005',
    event_id: 'evt010',
    amount: 150.00,
    payment_date: '2026-04-28',
    payment_method: 'credit_card',
    reference: 'ERR-2026-005',
    notes: 'Full payment',
    status: 'completed',
  },
  {
    id: 'pmt006',
    event_id: 'evt011',
    amount: 8100.00,
    payment_date: '2026-04-08',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-006',
    notes: 'Full payment',
    status: 'completed',
  },
  {
    id: 'pmt007',
    event_id: 'evt015',
    amount: 325.00,
    payment_date: '2026-05-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-007',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt008',
    event_id: 'evt016',
    amount: 170.00,
    payment_date: '2026-05-20',
    payment_method: 'cash',
    reference: 'ERR-2026-008',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt009',
    event_id: 'evt017',
    amount: 320.00,
    payment_date: '2026-04-20',
    payment_method: 'credit_card',
    reference: 'ERR-2026-009',
    notes: 'Full payment',
    status: 'completed',
  },
  {
    id: 'pmt010',
    event_id: 'evt019',
    amount: 2800.00,
    payment_date: '2026-05-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-010',
    notes: 'Deposit paid',
    status: 'completed',
  },
  {
    id: 'pmt011',
    event_id: 'evt023',
    amount: 450.00,
    payment_date: '2026-04-04',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-011',
    notes: 'Full payment',
    status: 'completed',
  },

  // ===== PAYMENTS FOR WEEK APR 20-26 =====
  // Missing payments for pre-existing complete events
  {
    id: 'pmt_fix01',
    event_id: 'evt007',
    amount: 450.00,
    payment_date: '2026-04-22',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-F01',
    notes: 'Full payment - HSE Health & Safety',
    status: 'completed',
  },
  {
    id: 'pmt_fix02',
    event_id: 'evt009',
    amount: 400.00,
    payment_date: '2026-04-24',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-F02',
    notes: 'Full payment - Holistic Fairs',
    status: 'completed',
  },

  // ===== PAYMENTS FOR WEEK APR 20-26 =====
  {
    id: 'pmt012',
    event_id: 'evt024',
    amount: 840.00,
    payment_date: '2026-04-01',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-012',
    notes: 'Deposit - Cavan County Council training',
    status: 'completed',
  },
  {
    id: 'pmt013',
    event_id: 'evt025',
    amount: 147.50,
    payment_date: '2026-04-08',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-013',
    notes: 'Deposit - Maguire & Patterson',
    status: 'completed',
  },
  {
    id: 'pmt014',
    event_id: 'evt026',
    amount: 787.50,
    payment_date: '2026-03-25',
    payment_method: 'credit_card',
    reference: 'ERR-2026-014',
    notes: 'Deposit - Brennan 21st birthday',
    status: 'completed',
  },
  {
    id: 'pmt015',
    event_id: 'evt027',
    amount: 420.00,
    payment_date: '2026-04-10',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-015',
    notes: 'Deposit - Gin Tasting',
    status: 'completed',
  },
  {
    id: 'pmt016',
    event_id: 'evt028',
    amount: 2100.00,
    payment_date: '2026-03-20',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-016',
    notes: 'Deposit - AIB Conference',
    status: 'completed',
  },
  {
    id: 'pmt017',
    event_id: 'evt030',
    amount: 270.00,
    payment_date: '2026-03-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-017',
    notes: 'Deposit - LEO Workshop',
    status: 'completed',
  },
  {
    id: 'pmt018',
    event_id: 'evt031',
    amount: 3125.00,
    payment_date: '2026-02-01',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-018',
    notes: 'Deposit - Lakeland Dairies AGM',
    status: 'completed',
  },
  {
    id: 'pmt019',
    event_id: 'evt032',
    amount: 1275.00,
    payment_date: '2026-03-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-019',
    notes: 'Deposit - Rotary Club Luncheon',
    status: 'completed',
  },
  {
    id: 'pmt020',
    event_id: 'evt033',
    amount: 975.00,
    payment_date: '2026-03-20',
    payment_method: 'credit_card',
    reference: 'ERR-2026-020',
    notes: 'Deposit - Maguire retirement',
    status: 'completed',
  },
  {
    id: 'pmt021',
    event_id: 'evt034',
    amount: 1237.50,
    payment_date: '2026-02-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-021',
    notes: 'Deposit - O\'Reilly/Flanagan rehearsal dinner',
    status: 'completed',
  },
  {
    id: 'pmt022',
    event_id: 'evt035',
    amount: 350.00,
    payment_date: '2026-04-20',
    payment_method: 'cash',
    reference: 'ERR-2026-022',
    notes: 'Full payment - Trad session',
    status: 'completed',
  },
  {
    id: 'pmt023',
    event_id: 'evt036',
    amount: 160.00,
    payment_date: '2026-04-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-023',
    notes: 'Deposit - IFA info evening',
    status: 'completed',
  },
  {
    id: 'pmt024',
    event_id: 'evt037',
    amount: 7875.00,
    payment_date: '2025-12-01',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-024',
    notes: 'Deposit - O\'Reilly/Flanagan wedding',
    status: 'completed',
  },
  {
    id: 'pmt025',
    event_id: 'evt038',
    amount: 240.00,
    payment_date: '2026-03-20',
    payment_method: 'credit_card',
    reference: 'ERR-2026-025',
    notes: 'Deposit - Brady communion',
    status: 'completed',
  },
  {
    id: 'pmt026',
    event_id: 'evt039',
    amount: 337.50,
    payment_date: '2026-04-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-026',
    notes: 'Deposit - Vintage Car Club',
    status: 'completed',
  },
  {
    id: 'pmt027',
    event_id: 'evt040',
    amount: 630.00,
    payment_date: '2026-03-15',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-027',
    notes: 'Deposit - Sheridan anniversary',
    status: 'completed',
  },
  {
    id: 'pmt028',
    event_id: 'evt041',
    amount: 240.00,
    payment_date: '2026-04-10',
    payment_method: 'bank_transfer',
    reference: 'ERR-2026-028',
    notes: 'Deposit - Mind Body Cavan',
    status: 'completed',
  },
];
